import { useSelector } from 'react-redux'

import { getClientId, getPatientId } from '~/store/reducers/soap'

import { PatientMedicalSummaryRail } from '../../summary/PatientMedicalSummaryRail'
import { SoapPatientTile, type SoapPatientTileProps } from './SoapPatientTile'

import styles from './SoapPatientMedicalRecordRightRail.module.scss'

export type SoapPatientMedicalRecordRightRailProps = Pick<
  SoapPatientTileProps,
  'clientId' | 'patientId' | 'showSoapActions'
>

export const SoapPatientMedicalRecordRightRail = ({
  clientId: clientIdProp,
  patientId: patientIdProp,
  showSoapActions = true,
}: SoapPatientMedicalRecordRightRailProps) => {
  const clientIdFromStore = useSelector(getClientId) ?? ''
  const patientIdFromStore = useSelector(getPatientId) ?? ''
  const clientId = clientIdProp ?? clientIdFromStore
  const patientId = patientIdProp ?? patientIdFromStore

  return (
    <div className={styles.rightRailContainer}>
      <div className={styles.patientDetailsHeader}>
        <SoapPatientTile
          clientId={clientIdProp}
          patientId={patientIdProp}
          showSoapActions={showSoapActions}
        />
      </div>
      <PatientMedicalSummaryRail clientId={clientId} patientId={patientId} />
    </div>
  )
}
